import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';

import categories from 'admin/reducers/categories';
import items from 'admin/reducers/items';
import settings from 'admin/reducers/settings';
import selection from './selection';
import popUp from './popUp';
import isBusy from './is-busy';
import user from './user';

export default combineReducers({
	categories,
	items,
	selection,
	settings,
	popUp,
	router,
	isBusy,
	user,
});
